"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAvatarCell = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const avatar_1 = require("../avatar/avatar");
const featured_cell_1 = require("./featured_cell");
const styles_1 = require("../../styles");
const IconAvatarCellWrapper = (0, styles_1.styled)('div')({
    display: 'flex',
    alignItems: 'center',
    minWidth: '200px',
});
const UserAvatarCell = ({ headline, subHeadline, onClick, avatarUrl = '', }) => ((0, jsx_runtime_1.jsxs)(IconAvatarCellWrapper, Object.assign({ onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(avatar_1.Avatar, { src: avatarUrl, displayName: headline, marginRight: '20px', size: 'small' }), (0, jsx_runtime_1.jsx)(featured_cell_1.ListRowFeaturedCell, { testid: "user-cell", headline: headline, subHeadline: subHeadline })] })));
exports.UserAvatarCell = UserAvatarCell;
//# sourceMappingURL=user_avatar.js.map